import { render, staticRenderFns } from "./ComingSoonCard.vue?vue&type=template&id=13d78414&scoped=true&"
import script from "./ComingSoonCard.vue?vue&type=script&lang=ts&"
export * from "./ComingSoonCard.vue?vue&type=script&lang=ts&"
import style0 from "./ComingSoonCard.vue?vue&type=style&index=0&id=13d78414&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d78414",
  null
  
)

export default component.exports